    <p-dialog
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [closable]="true"
    [(visible)]="visible"
    (onHide)="hideDialog()"
    [style]="{width: '80%', height: '750px'}">
    <ng-template pTemplate="header">
        <div class="discard-header flex">Add Product for Driver</div>
    </ng-template>
        <div class="flex flex-row mb-4">
            <img class="service-icon" src="Content/xpress-app/images/{{getServiceTypeIcon(driver?.Services[0])}}.svg" />
            <div class="flex flex-column ml-3">
                <div class="driver-name">
                    {{driver?.UserName}}
                </div>
                <div class="driver-service">
                    Service Type: 
                    <span class="services" *ngFor="let service of driver?.Services; let i = index">
                        {{service}}{{i+1 === driver?.Services.length ? '' : ', '}}
                    </span>
                </div>
            </div>
        </div>
    <ng-template pTemplate="body">
        <p-steps 
            [model]="menuItems" 
            [readonly]="true" 
            [activeIndex]="activeIndex" 
            (activeIndexChange)="onActiveIndexChange($event)" />

        <ng-container *ngIf="activeIndex === 0">
            <p-scrollPanel [style]="{ width: '100%', height: '445px' }">
                <add-availed-product-details (isProductDetailsNotValid)="isFormValid($event)"></add-availed-product-details>
            </p-scrollPanel>
        </ng-container>
        <div *ngIf="activeIndex === 1">
            <p-scrollPanel [style]="{ width: '100%', height: '445px' }">
                <add-availed-product-payment-terms (paymentTermsNotValid)="isFormValid($event)"></add-availed-product-payment-terms>
            </p-scrollPanel>
        </div>
        <div *ngIf="activeIndex === 2">
            <p-scrollPanel [style]="{ width: '100%', height: '445px' }">
                <add-availed-product-summary></add-availed-product-summary>
            </p-scrollPanel>
        </div>
    </ng-template>
    <ng-template pTemplate="footer">
        <div *ngIf="activeIndex !== 2" class="flex flex-column text-left text-blue-400 mb-3" [innerHtml]="warningMessage[activeIndex]">
        </div>
        <div *ngIf="activeIndex !== 0" class="float-left">
        <p-button
            [text]="true"
            label="Back"
            icon="pi pi-angle-left" 
            class="add-product-back-btn"
            (onClick)="previousStep()"/>
        </div>
        <p-button 
            *ngIf="activeIndex !== 2"
            [disabled]="isFormNotValid[activeIndex]"
            label="Next" 
            class="add-product-next-btn"
            (onClick)="nextStep()"
          />
        <p-button 
            *ngIf="activeIndex === 2"
            label="Save" 
            [disabled]="loading"
            class="add-product-next-btn"
            (onClick)="saveProduct()"
          />
    </ng-template>
</p-dialog>
